import { useNavigate } from "react-router-dom";
import { createContext, useEffect, useState, useContext } from 'react';
import { useSelector } from 'react-redux';
import { useFirestore } from "react-redux-firebase";
import { getFunctions, httpsCallable } from "firebase/functions";
import { collectionToArray } from '@/utils/collectionToArray'
import { AuthContext } from "./AuthContext";

const StakeContext = createContext(null)

const StakeProvider = ({ children }) => {
  const firestore = useFirestore();

  const functions = getFunctions();
  const functionCreateDuel = httpsCallable(functions, 'createDuel');
  const functionDeleteDuel = httpsCallable(functions, 'deleteDuel');
  const functionAcceptDuel = httpsCallable(functions, 'acceptDuel');
  const functionHandleRematch = httpsCallable(functions, 'handleRematch');
  const functionUpdateRematch = httpsCallable(functions, 'updateRematch');
  const functionCompleteDuel = httpsCallable(functions, 'completeDuel');
  const functionChatDuel = httpsCallable(functions, 'chatDuel');
  const [stakes, setStakes] = useState([]);
  const [translatedStakes, setTranslatedStakes] = useState([]);
  const [translatedRecentDuels, setTranslatedRecentDuels] = useState([]);
  const [translatedRecentUserDuels, setTranslatedRecentUserDuels] = useState([]);
  const [translatedRecentHighrollerDuels, setTranslatedRecentHighrollerDuels] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [errors, setErrors] = useState(null);
  const router = useNavigate();
  const { auth } = useContext(AuthContext)

  const duels = useSelector((state) => state.firestore.data.duels);
  const allDuels = useSelector((state) => state.firestore.data.allDuels);
  const recentDuels = useSelector((state) => state.firestore.data.recentDuels);
  const recentUserCreatedDuels = useSelector((state) => state.firestore.data.recentUserCreatedDuels);
  const recentUserJoinedDuels = useSelector((state) => state.firestore.data.recentUserJoinedDuels);
  const recentHighrollerDuels = useSelector((state) => state.firestore.data.recentHighrollerDuels);
  const taxRate = useSelector((state) => state.firestore.data.taxRate);

  // useEffect(() => {
  //   if (duels && typeof duels !== "undefined") {
  //     const duelKeys = Object.keys(duels)
  //     setStakes(duelKeys ? duelKeys.map((duelKey) => {
  //       if (duels[duelKey]) {
  //         return {
  //           id: duelKey,
  //           allowedWeapons: duels[duelKey].allowedWeapons ? duels[duelKey].allowedWeapons : null,
  //           created: duels[duelKey].created ? duels[duelKey].created.id : null,
  //           createdUid: duels[duelKey].createdUid ? duels[duelKey].createdUid : null,
  //           createdUser: duels[duelKey].created ? duels[duelKey].created : null,
  //           joined: duels[duelKey].joined ? duels[duelKey].joined.id : null,
  //           joinedUid: duels[duelKey].joinedUid ? duels[duelKey].joinedUid : null,
  //           joinedUser: duels[duelKey].joined ? duels[duelKey].joined : null,
  //           creationTime: duels[duelKey].creationTime ? duels[duelKey].creationTime.toDate() : null, //when the duel was created in the app
  //           expiresAt: duels[duelKey].expiryTime ? duels[duelKey].expiryTime.toDate() : null, //how long the players have to find each other - would be on the initial screen in StartDuel
  //           duelStart: duels[duelKey].duelStart ? duels[duelKey].duelStart.toDate() : null, //once the duel starts, this is set, and the healthbars show in StartDuel
  //           fightStart: duels[duelKey].fightStart ? duels[duelKey].fightStart.toDate() : null, //once this is set, we ought to start getting health updates (redundant - no change in screen)
  //           fightEnd: duels[duelKey].fightEnd ? duels[duelKey].fightEnd.toDate() : null, //once this is set, theres a winner, and players ought to see the summary screen
  //           wager: duels[duelKey].wager ? duels[duelKey].wager : null,
  //           winner: duels[duelKey].winner?.id ? duels[duelKey].winner?.id : null,
  //           payout: duels[duelKey].payout ? duels[duelKey].payout : null,
  //           createdHp: duels[duelKey].createdHp ? duels[duelKey].createdHp : null,
  //           joinedHp: duels[duelKey].joinedHp ? duels[duelKey].joinedHp : null,
  //           rematchOffered: duels[duelKey].rematchOffered ? duels[duelKey].rematchOffered : null,
  //           declined: duels[duelKey].declined ? duels[duelKey].declined : null
  //         }
  //       }
  //     }) : [])
  //     setIsLoading(false)
  //   } else {
  //     setStakes([])
  //     setIsLoading(false)
  //   }
  // }, [duels])

  // useEffect(async () => {
  //   if (stakes?.length > 0) {
  //     const promises = stakes.map(async (stake) => {
  //       if (stake) {
  //         return {
  //           ...stake,
  //           createdDoc: await stake.createdUser.get(),
  //           createdAccounts: await firestore.collection("accounts").where("ownerUid", "==", stake.createdUid).where("primary", "==", true).get(),
  //           joinedDoc: stake.joinedUser ? await stake.joinedUser.get() : null,
  //           joinedAccounts: await firestore.collection("accounts").where("ownerUid", "==", stake.joinedUid).where("primary", "==", true).get(),
  //         }
  //       }
  //     });
  //     const result = await Promise.all(promises);
  //     setTranslatedStakes(result)
  //   } else {
  //     setTranslatedStakes([])
  //   }
  // }, [stakes])

  useEffect(() => {
    firestore.collection("duels").where("hidden", "==", false).onSnapshot((snapshot) => {
      let duelsArr = []
      snapshot.docs.forEach(async (doc) => {
        const data = doc.data()
        duelsArr.push({
          id: doc.id,
          completed: data.completed ? data.completed : false,
          allowedWeapons: data.allowedWeapons ? data.allowedWeapons : null,
          created: data.created ? data.created.id : null,
          createdUid: data.createdUid ? data.createdUid : null,
          createdUser: data.created ? data.created : null,
          joined: data.joined ? data.joined.id : null,
          joinedUid: data.joinedUid ? data.joinedUid : null,
          joinedUser: data.joined ? data.joined : null,
          creationTime: data.creationTime ? data.creationTime.toDate() : null, //when the duel was created in the app
          expiresAt: data.expiryTime ? data.expiryTime.toDate() : null, //how long the players have to find each other - would be on the initial screen in StartDuel
          duelStart: data.duelStart ? data.duelStart.toDate() : null, //once the duel starts, this is set, and the healthbars show in StartDuel
          fightStart: data.fightStart ? data.fightStart.toDate() : null, //once this is set, we ought to start getting health updates (redundant - no change in screen)
          fightEnd: data.fightEnd ? data.fightEnd.toDate() : null, //once this is set, theres a winner, and players ought to see the summary screen
          wager: data.wager ? data.wager : null,
          winner: data.winner?.id ? data.winner?.id : null,
          payout: data.payout ? data.payout : null,
          createdHp: data.createdHp ? data.createdHp : null,
          joinedHp: data.joinedHp ? data.joinedHp : null,
          rematchOffered: data.rematchOffered ? data.rematchOffered : null,
          declined: data.declined ? data.declined : null,
          // createdDoc: await data.created.get(),
          // joinedDoc: data.joined ? await data.joined.get() : null,
        })
      })
      setTranslatedStakes(duelsArr)
      setIsLoading(false)
    })
  }, [])

  const getUsernamesByDuelId = async (id) => {
    const duelSnapshot = await firestore.collection("duels").doc(id).get()
    if (!duelSnapshot) return null

    const createdUserSnapshot = await firestore.collection(`users/${duelSnapshot.data().createdUid}/accounts`).where("primary", "==", true).get()
    const joinedUserSnapshot = await firestore.collection(`users/${duelSnapshot.data().joinedUid}/accounts`).where("primary", "==", true).get()

    if (!createdUserSnapshot.empty && !joinedUserSnapshot.empty) {
      return {
        created: createdUserSnapshot?.docs[0]?.data()?.username || null,
        joined: joinedUserSnapshot?.docs[0]?.data()?.username || null
      }
    }
  }

  const translateCompletedDuel = async (stake) => {
    const createdRef = await stake?.created?.get()
    const created = createdRef.data()
    const joinedRef = await stake?.joined?.get()
    const joined = joinedRef?.data()

    return {
      id: stake?.id,
      winner: stake?.winner?.id == stake?.created?.id ? 'created' : 'joined',
      created: created?.privacy?.stats ? 'Hidden' : created?.username,
      joined: joined?.privacy?.stats ? 'Hidden' : joined?.username,
      wager: stake?.wager,
      endAt: stake?.fightEnd,
      payout: stake?.payout,
      userWon: stake?.winner?.id == auth.uid
    }
  }

  useEffect(async () => {
    const recentDuelsArray = collectionToArray(recentDuels).filter(duel => duel.joined && duel.fightEnd && duel.winner)
    const promises = recentDuelsArray.map(stake => translateCompletedDuel(stake));
    const result = await Promise.all(promises)
    setTranslatedRecentDuels(result)
  }, [recentDuels])

  useEffect(async () => {
    const recentHighrollerDuelsArray = collectionToArray(recentDuels).filter(duel => duel.wager >= 1000000000)
    const promises = recentHighrollerDuelsArray.map(stake => translateCompletedDuel(stake));
    const result = await Promise.all(promises)
    setTranslatedRecentHighrollerDuels(result)
  }, [recentDuels])

  useEffect(async () => {
    const recentUserCreatedDuelsArray = collectionToArray(recentUserCreatedDuels).filter(duel => duel.created.id == auth?.uid)
    const recentUserJoinedDuelsArray = collectionToArray(recentUserJoinedDuels).filter(duel => duel.joined.id == auth?.uid)
    const recentUserDuelsArray = [...recentUserCreatedDuelsArray, ...recentUserJoinedDuelsArray]
    const promises = recentUserDuelsArray.map(stake => translateCompletedDuel(stake))
    const result = await Promise.all(promises)
    setTranslatedRecentUserDuels(result)
  }, [recentDuels])

  // useEffect(async () => {
  //   const recentUserCreatedDuelsArray = collectionToArray(recentUserCreatedDuels)
  //   const recentUserJoinedDuelsArray = collectionToArray(recentUserJoinedDuels)
  //   const recentUserDuelsArray = [...recentUserCreatedDuelsArray, ...recentUserJoinedDuelsArray]
  //     .filter(duel => duel.joined && duel.fightEnd && duel.winner)
  //   const promises = recentUserDuelsArray.map(stake => translateCompletedDuel(stake))
  //   const result = await Promise.all(promises)
  //   setTranslatedRecentUserDuels(result)
  // }, [recentUserCreatedDuels, recentUserJoinedDuels])

  // useEffect(async () => {
  //   const recentHighrollerDuelsArray = collectionToArray(recentHighrollerDuels)
  //     .filter(duel => duel.joined && duel.fightEnd && duel.winner && duel.wager >= 500000000)
  //   const promises = recentHighrollerDuelsArray.map(stake => translateCompletedDuel(stake))
  //   const result = await Promise.all(promises)
  //   setTranslatedRecentHighrollerDuels(result)
  // }, [recentHighrollerDuels])

  const offerRematch = (duel, wager) => {
    const runHandleRematch = async () => {
      try {
        await functionHandleRematch({
          type: 'offer',
          duel: duel.id,
          rematchOffered: {
            offered: true,
            accepted: null,
            created: false,
            wager: Number(wager)
          }
        });
      } catch (error) {
        console.log(error)
      }
    }
    runHandleRematch();
  }

  const cancelRematch = (duel) => {
    const runHandleRematch = async () => {
      try {
        return await functionHandleRematch({
          type: 'cancel',
          duel: duel.id,
          rematchOffered: {
            revoked: true,
            offered: false,
            accepted: null,
            created: false,
          }
        });
      } catch (error) {
        console.log(error)
      }
    }
    return runHandleRematch();
  }

  const acceptRematch = (duel) => {
    const runHandleRematch = async () => {
      try {
        return await functionHandleRematch({
          type: 'accept',
          duel: duel.id,
          rematchOffered: { ...duel.rematchOffered, accepted: true }
        });
      } catch (error) {
        console.log(error)
      }
    }
    return runHandleRematch();
  }

  const declineRematch = (duel) => {
    const runHandleRematch = async () => {
      try {
        return await functionHandleRematch({
          type: 'decline',
          duel: duel.id,
          rematchOffered: { ...duel.rematchOffered, accepted: false }
        });
      } catch (error) {
        console.log(error)
      }
    }
    return runHandleRematch();
  }

  const updateRematch = (originalDuel, duel) => {
    const runUpdateRematch = async () => {
      try {
        return await functionUpdateRematch(duel).then(docRef => {
          functionHandleRematch({
            type: 'update',
            duel: originalDuel.id,
            rematchOffered: { ...originalDuel.rematchOffered, rematchId: docRef.data }
          }).then(async () => {
            // return setTimeout(async () => {
            return await functionCompleteDuel(originalDuel.id);
            // }, 1000)
          });
        });
      } catch (error) {
        console.log(error)
      }
    }
    return runUpdateRematch();
  }

  const chatDuel = (id, payload) => {
    const sendDuelChatMessage = async () => {
      try {
        await functionChatDuel({ id, payload });
      } catch (error) {
        console.log(error)
      }
    }
    sendDuelChatMessage();
  }

  const fetchStakeById = (id) => {
    return stakes.filter(stake => stake.id == id)[0]
  }

  return (<StakeContext.Provider value={{
    allDuels, getUsernamesByDuelId, translatedRecentDuels, translatedRecentUserDuels, translatedRecentHighrollerDuels, taxRate, offerRematch, acceptRematch, declineRematch, cancelRematch, updateRematch, chatDuel, duels, stakes, translatedStakes, fetchStakeById, errors, isLoading
  }}>
    {children}
  </StakeContext.Provider>)
}

export { StakeProvider, StakeContext }